import { useQuery } from '@fv/client-core'

import { adminFetch } from '@/utils'

type ContextDTO = {
  liveEventsUri?: string
  sessionId: string
}

export async function fetchAdminContext() {
  return adminFetch<ContextDTO>('/context')
}

export function useAdminContext() {
  return useQuery(['adminContext'], fetchAdminContext, {
    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
  })
}
